<div class="alert-modal-wrapper">
    <div class="alert-modal-content">
        <div class="exit-button" (click)="closeModal()">
            <mat-icon>close</mat-icon>
        </div>
        <!-- <div class="icon">
            <mat-icon color="warn" class="cancel">error_outline</mat-icon>
        </div> -->

        <div class="icon">
            <svg class="error-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="100%" height="100%" viewBox="0 0 64 64" version="1.1" fit="" preserveAspectRatio="xMidYMid meet"
                focusable="false">
                <path class="checked"
                    d="M 32 0.539062 C 14.652344 0.539062 0.539062 14.652344 0.539062 32 C 0.539062 49.347656 14.652344 63.460938 32 63.460938 C 49.347656 63.460938 63.460938 49.347656 63.460938 32 C 63.460938 14.652344 49.347656 0.539062 32 0.539062 Z M 32 5.378906 C 46.726562 5.378906 58.621094 17.273438 58.621094 32 C 58.621094 46.726562 46.726562 58.621094 32 58.621094 C 17.273438 58.621094 5.378906 46.726562 5.378906 32 C 5.378906 17.273438 17.273438 5.378906 32 5.378906 Z M 22.847656 19.371094 L 19.371094 22.847656 L 28.519531 32 L 19.371094 41.152344 L 22.847656 44.628906 L 32 35.480469 L 41.152344 44.628906 L 44.628906 41.152344 L 35.480469 32 L 44.628906 22.847656 L 41.152344 19.371094 L 32 28.519531 Z M 22.847656 19.371094 ">
                </path>
            </svg>
        </div>

        <div *ngIf="showHeader" class="header">
            <h1 mat-dialog-title>{{ data.title }}</h1>
        </div>
        <div mat-dialog-content>
            <p class="dialog-message message" [ngClass]="'message' + i"
                *ngFor="let message of data.messages; let i = index">{{
                message }}</p>
        </div>
        <div mat-dialog-actions>
            <button *ngIf="hasCancelButton" mat-flat-button color="primary" class="tql-style" (click)="cancel()">{{
                data.cancelText }}</button>
            <button *ngIf="hasConfirmButton" mat-flat-button color="primary" class="tql-style" class="btn"
                (click)="confirm()">{{ data.confirmText }}</button>
        </div>
    </div>
</div>